jQuery(function ($) {

  // 1) 초기 세팅
  $('.SidebarMenu__Nav > li.menu-link').each(function () {
    const $li = $(this);
    const $wrap = $li.children('.dropdown-child_wrap');

    if ($wrap.length > 0) {
      $li.addClass('has_dropdown');

      // 열려있는 것만 flex, 나머지 숨김
      if ($li.hasClass('show')) {
        $wrap.css('display', 'flex');
      } else {
        $wrap.hide();
      }
    }
  });

 
  const $defaultLi = $('.SidebarMenu__Nav > li:nth-child(5)');
  const $defaultWrap = $defaultLi.children('.dropdown-child_wrap');

  $defaultLi.addClass('show');

  if ($defaultWrap.length) {
    $defaultWrap
      .css('height', '479px')
      .css('display', 'flex');
  }


  $('.SidebarMenu__Nav').on('click', '> li.menu-link > a', function (e) {
    const $a = $(this);
    const $li = $a.parent('li.menu-link');
    const $wrap = $li.children('.dropdown-child_wrap');

    if ($wrap.length === 0) return;


    e.preventDefault();

    const isOpen = $li.hasClass('show');


    $('.SidebarMenu__Nav > li.menu-link.show')
      .not($li)
      .removeClass('show')
      .children('.dropdown-child_wrap')
      .hide();

  
    if (!isOpen) {
      $li.addClass('show');
      $wrap.css('display', 'flex');
    } else {
      $li.removeClass('show');
      $wrap.hide();
    }
  });


  $('.SidebarMenu__Nav').on('click', '.dropdown-child_wrap a', function (e) {
    e.stopPropagation(); 
  });


$('.m_menu_close, .pageOverlay').on('click', function () {
    $('.SidebarMenu').removeClass('show');
    $('body').removeClass('noScroll');
    $('.pageOverlay').removeClass('on');
  });

});
